module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "id": "main-video",
      "src": "https://player.vimeo.com/video/229538519",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump Free Episode: Fridge Terror")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "grid-48 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/235354279",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump: Episode 1 : Tiny Toaster")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229698811?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-48 grid-parent margin-left-4"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/229698465",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump: Episode 2: Pogo Donkey")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229687750?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "grid-48 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/229698526",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump: Episode 3: Mouse Jamboree")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229689650?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-48 grid-parent margin-left-4"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/229698719",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump: Episode 4: Drunk Scalextric")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229692537?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "grid-48 grid-parent"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/229698662",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v("Brain Dump: Episode 5 : Aggressive Twiddling")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229694282?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-48 grid-parent margin-left-4"
  }, [_c('div', {
    staticClass: "video-item grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video-header grid-100 grid-parent"
  }, [_c('div', {
    staticClass: "video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/229698428",
      "width": "640",
      "height": "352",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _c('h4', [_vm._v(" Brain Dump: Episode 6 : Harpsichord")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com//store/ondemand/buy/120415/229696148?popup=true&r="
    }
  }, [_c('div', {
    staticClass: "buy-cta white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("£3.50")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://vimeo.com/ondemand/rossnoble"
    }
  }, [_c('div', {
    staticClass: "buy-cta all white"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("All Videos")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0b991cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OnDemand/OriginalContent.vue
// module id = 291
// module chunks = 0